export const APP_PANE_NAME_PREFIX = 'owa-app-pane-';
export const HEADER_PANE_NAME_PREFIX = 'owa-header-pane-';
